<template>
  <div class="v-progress">
    <div class="v-progress__inner">
      <div class="v-progress__goal">
        <img src="/img/island.svg" alt="" />
        <img
          class="icon-check"
          src="/img/accepted.svg"
          alt=""
          ref="completeIcon"
        />
      </div>
      <div class="v-progress__bar">
        <div
          v-for="n in steps"
          :key="n"
          class="v-progress__step"
          :ref="`step_${n}`"
        ></div>
        <div
          v-if="!animationCompleted || currentStep !== steps"
          class="v-progress__icon"
          ref="icon"
        >
          <img src="/img/plane.svg" alt="" />
        </div>
      </div>
    </div>

    <p
      v-if="animationCompleted && currentStep === steps && errors === 0"
      class="v-progress__message text-center fnt font-deco"
      v-html="successMsg"
    ></p>
  </div>
</template>

<script>
import $ from "jquery"
import { TimelineLite, Linear } from "gsap/TweenMax"

export default {
  name: "Progress",
  props: {
    steps: {
      type: Number,
      default: 5
    },
    step: {
      type: Number,
      default: 1
    }
  },
  data: function() {
    return {
      currentStep: 1,
      animationCompleted: true,
      errors: 0
    }
  },
  computed: {
    successMsg() {
      return this.$t("STATUS__COMPLETED")
    }
  },
  watch: {
    step: {
      handler(val) {
        this.updateProgress(val)
      }
    }
  },
  methods: {
    updateProgress(step) {
      if (step < 1) {
        this.currentStep = 1
      } else if (step > this.steps) {
        this.currentStep = this.steps
      } else {
        this.currentStep = step
      }

      this.setLeftOffset()
    },
    // get left offset of based on current step
    setLeftOffset() {
      const vm = this
      this.animationCompleted = false
      const $step = $(".v-progress__step").eq(this.currentStep - 1)
      const $icon = $(this.$refs.icon)
      const posLeft = $step.position().left
      const left = posLeft + $step.outerWidth() / 2 - $icon.outerWidth() / 2
      const tl = new TimelineLite()
      tl.to(this.$refs.icon, this.getTransitionDuration(), {
        left: left + "px",
        ease: Linear.easeNone,
        delay: 0.3,
        onComplete: vm.onComplete,
        onCompleteScope: vm
      })
    },
    onComplete() {
      //const icon = this.$refs.completeIcon
      this.animationCompleted = true
      //
      //if (this.currentStep === this.steps) {
      //  const tl = new TimelineLite()
      //
      //  tl.to(icon, 0.5, {
      //    opacity: 1,
      //    ease: Linear.easeNone
      //  }).to(
      //    icon,
      //    0.5,
      //    {
      //      rotation: 360,
      //      ease: Power2.easeOut
      //    },
      //    0
      //  )
      //}
    },
    // get transition duration in seconds
    getTransitionDuration() {
      const duration = this.currentStep * 0.6
      return Math.round(duration * 10) / 10
    }
  },
  mounted() {
    // this.updateProgress(this.step)
  }
}
</script>

<style lang="scss" scoped>
.v-progress {
  margin-bottom: 25px;
  padding: 0 25px;
}

.v-progress__inner {
  height: 50px;
  position: relative;
  margin-bottom: 5px;
}

.v-progress__bar {
  align-items: center;
  background-color: orange;
  display: flex;
  height: 5px;
  justify-content: space-between;
  left: 0;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 100%;
}

.v-progress__goal {
  position: absolute;
  right: 0;
  top: -28px;
  transform: translateX(41%);
  width: 80px;
  z-index: 1;

  .icon-check {
    position: absolute;
    width: 34px;
    top: 31px;
    left: 24px;
    opacity: 0;
  }
}

.v-progress__step {
  background-color: #777;
  border-radius: 50%;
  height: 15px;
  width: 15px;
}

.v-progress__icon {
  left: 0;
  position: absolute;
  top: 50%;
  transform: translate3d(0, -50%, 0);
  width: 70px;

  img {
    display: block;
    max-width: 100%;
  }
}

.v-progress__message {
}
</style>
